import { Typography } from '@mui/material';

type UserProfileTenantDisplayNameProps = {
  tenantName: string;
};

export const UserProfileTenantDisplayName = ({ tenantName }: UserProfileTenantDisplayNameProps) => {
    return (
        <div style={{ marginLeft: '1rem' }}>
            <Typography sx={{
                flexShrink: 0,
                textAlign: 'left',
                pointerEvents: 'auto',
                width: 'fit-content',
                fontWeight: 'bold'
            }}>
                {tenantName}
            </Typography>
        </div>
    );
};
